import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Configuration, TFMService } from 'app/mock-api/tfm.service';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CarouselAllModule } from '@syncfusion/ej2-angular-navigations';
import { MatTabsModule } from '@angular/material/tabs';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'whatsapp-view-dialog',
  standalone: true,
  imports: [ MatIconModule, CarouselAllModule, MatTabsModule, MatButtonModule, GoogleMapsModule, MatTooltipModule, MatDialogModule ],
  providers: [TFMService],
  templateUrl: './whatsapp-view-dialog.component.html',
  styleUrl: './whatsapp-view-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Default
})
export class WhatsappViewDialogComponent implements OnInit {

  public view: any = {
  
  }

  /**
   * Constructor
   */
  constructor(private _tfmService : TFMService, private _tfmCartService: TFMCartService, private _config: Configuration, public dialogRef: MatDialogRef<WhatsappViewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private sanitizer: DomSanitizer)
  {
    this.view.type = data.type;
    this.view.search = data.search;
    this.view.config = data.config;
    this.view.itin = data.itin;

    // View quote in browser
    this.view.quoteViewInBrowser = this.sanitizer.bypassSecurityTrustResourceUrl(`${this._config.TFMApiLink.href}v1/sites/${this.view.itin.content.itinerary.siteId}/itineraries/${this.view.itin.content.itinerary.guid}/documents/pdf/ss?v=c"`)
    // Send quote in WhatsApp. Download quote
    this.view.quoteSendAndViewAsWhatsapp = this.sanitizer.bypassSecurityTrustResourceUrl(`https://api.whatsapp.com/send?text=You may download and view your quotation here: https://api.travelfind.me/v1/sites/${this.view.itin.content.itinerary.siteId}/itineraries/${this.view.itin.content.itinerary.guid}/documents/pdf/ss?v=c"`);
    // Send quote in WhatsApp. View in browser
    this.view.quoteSendAsWhatsapp = this.sanitizer.bypassSecurityTrustResourceUrl(`https://api.whatsapp.com/send?text=You may download and view your quotation here: https://api.travelfind.me/v1/sites/${this.view.itin.content.itinerary.siteId}/itineraries/${this.view.itin.content.itinerary.guid}/documents/pdf"`);
    // Download quote directly
    this.view.quoteDownloadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${this._config.TFMApiLink.href}v1/sites/${this.view.itin.content.itinerary.siteId}/itineraries/${this.view.itin.content.itinerary.guid}/documents/pdf`);
  }

  /**
  * On init
  */
  ngOnInit(): void {

  }

  close(): void {
    // Close the dialog
    this.dialogRef.close();
  }
}
